// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@tps/XDL/types";

export default {
    primary: {
        main: "#0A57A4",
        contrast: "#FFFFFF",
    },
    secondary: {
        main: "#2E2B26",
        contrast: "#FFFFFF",
    },
    common: {
        background: "#FFFFFF",
        backgroundContrast: "#363636",
        accent: "#F8F9FA",
        accentContrast: "#363636",
        disabled: "#EEEEEE",
        border: "#CCCCCC",
        ui1: "#FFFFFF",
        ui2: "#EEEEEE",
        ui3: "#CCCCCC",
        ui4: "#999999",
        ui5: "#58585A",
        ui6: "#333333",
        ui7: "#000000",
        ui8: "#298CF0",
        ui9: "#063B6F",
        white: "#FFFFFF",
        black: "#000000",
    },
    text: {
        main: "#333333",
        disabled: "#475353",//
        accent: "#2D3435",//
        link: "#0A57A4",
    },
    success: {
        main: "#00A65A",
        light: "#D9F2E7",
        contrast: "#FFFFFF",
    },
    danger: {
        main: "#E4104E",
        light: "#FBDBE5",
        contrast: "#FFFFFF",
    },
    warning: {
        main: "#DAA91C",
        light: "#FDF9DE",
        contrast: "#FFFFFF",
    },
    info: {
        main: "#53ACDB",
        light: "#DDEEF8",
        contrast: "#FFFFFF",
    },
} as xBaseTheme["colors"];
